import { Alert, Button } from '@mui/material';
import type { ReactNode } from 'react';

type RetryAlertProps = {
  children: ReactNode;
  onRetry: () => unknown;
};

const RetryAlert = ({ children, onRetry }: RetryAlertProps) => (
  <Alert
    severity='error'
    action={
      <Button variant='text' color='error' size='small' onClick={() => void onRetry()}>
        Retry
      </Button>
    }
  >
    {children}
  </Alert>
);

export default RetryAlert;
